<template>
    <div class="mt-3">
        <b-table responsive striped hover sticky-header :fields="fieldsTableData" :items="listData"
            class="b-table-list">
            <template #head(stt)="data">
                <span class="col-table">{{ data.label }}</span>
            </template>
            <template #head(name)="data">
                <span class="col-table">{{ data.label }}</span>
            </template>
            <template #cell(stt)="row">
                {{ row.item.stt }}
            </template>
            <template #cell(subjectName)="row">
                {{ row.item.subjectName }}
            </template>
            <template #cell(lessonName)="row">
                {{ row.item.lessonName }}
            </template>
            <template #cell(completeRate)="row">
                {{ row.item.completeRate != null ? formatCompleteRate(row.item.completeRate) + '%' : '-' }}
            </template>
            <template #cell(missionRate)="row">
                {{ row.item.missionRate != null ? (row.item.missionRate > 100 ? 100 :
                    formatNumber(row.item.missionRate)) + '%' : '-' }}
            </template>
            <template #cell(completeDate)="row">
                {{ row.item.completeDate != null ? moment(row.item.completeDate).format('DD/MM/YYYY - HH:mm') : '-' }}
            </template>
            <template #table-caption v-if="listData.length == 0">Chưa có dữ liệu kế hoạch bài dạy</template>
        </b-table>
    </div>
</template>
<script>
import moment from "moment"
import { getListLessonPlaning } from './../../_api/lessonClassSchoolUserServices';
import { vueCustomScrollbar } from "vue-custom-scrollbar";
export default {
    components: {
        vueCustomScrollbar
    },
    props: {
        subjectId: {
            type: Number,
            default: 0
        },
        classId: {
            type: Number,
            default: 0
        },
        keyword: {
            type: String,
            default: ''
        },
    },
    watch: {
        'subjectId': 'getListLessonPlaningBySubjectId',
        'keyword': 'getListLessonPlaningBySubjectId',
        'classId': 'getListLessonPlaningBySubjectId',
    },
    data() {
        return {
            paramQueryData: {
                keyword: '',
                pageIndex: 1,
                pageSize: 5000000,
                subjectId: 0,
                classId: 0,
            },
            fieldsTableData: [
                { key: 'stt', label: 'STT', thClass: 'w-60px', tdClass: 'w-60px' },
                { key: 'subjectName', label: 'Môn học', thClass: 'w-150px', tdClass: 'w-150px' },
                { key: 'lessonName', label: 'Tên kế hoạch bài dạy' },
                { key: 'completeRate', label: 'Tiến độ hoàn thành' },
                { key: 'missionRate', label: 'Tỉ lệ đúng nhiệm vụ' },
                { key: 'completeDate', label: 'Thời gian hoàn thành' }
            ],
            listData: [],
        }
    },
    computed: {

    },
    mounted() {
        if (this.classId > 0) {
            this.getListLessonPlaningBySubjectId()
        }
    },
    methods: {
        moment,
        formatNumber(value) {
            if (typeof value !== 'number') {
                return value;
            }
            if (value % 1 == 0.5) {
                return value.toFixed(1);
            }
            return value.toFixed(2);
        },
        formatCompleteRate(value) {
            if (typeof value !== 'number') {
                return value;
            }
            return Number(value.toFixed(2));
        },
        getListLessonPlaningBySubjectId() {
            this.listData = []
            this.paramQueryData.subjectId = this.subjectId
            this.paramQueryData.keyword = this.keyword
            this.paramQueryData.classId = this.classId
            getListLessonPlaning(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors && res.data.list != null) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];
                        this.listData.push({
                            'stt': i + 1,
                            'classSchoolId': this.classSchoolId,
                            'subjectId': item.subjectId,
                            'subjectName': item.subjectName,
                            'lessonName': item.lessonName,
                            'completeRate': item.completeRate,
                            'missionTrue': item.missionTrue,
                            'missionTotal': item.missionTotal,
                            'missionRate': item.completeRate * 1 >= 100 ? this.formatNumber((item.missionTrue || 0) / (item.missionTotal || 1) * 100) : null,
                            'completeDate': item.completeDate,
                        })
                    }
                    this.totalRecords = res.data.paging.totalRecords
                }
            })
        }
    }
}
</script>